module.exports = "<example-shell\n  exampleId=\"sorting\" [title]=\"title\" [summary]=\"summary\" [dataSnippet]=\"dataSnippet\" [events]=\"events\" (clear)=\"clearEvents()\">\n  <stackline-data-table\n    title=\"Sortable inventory\"\n    [columns]=\"inventoryColumns\"\n    [data]=\"inventory\"\n    defaultSortFieldId=\"stock\"\n    [defaultSortAsc]=\"false\"\n    [striped]=\"true\"\n    [highlightOnHover]=\"true\"\n    (sortChange)=\"record('inventory sort', $event)\">\n  </stackline-data-table>\n</example-shell>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/sorting/sorting.component.html
// module id = ./src/app/examples/sorting/sorting.component.html
// module chunks = main